<template>
  <v-menu :close-on-content-click="false">
    <template #activator="{ props }">
      <v-tooltip location="bottom center">
        <template #activator="{ props: tooltip }">
          <div v-bind="props">
            <v-btn-icon
              v-ripple="false"
              data-testid="settingsMenu.settings-button"
              v-bind="tooltip"
              icon="mdi-cog"
              :class="[{ 'px-5': display.sm }, { 'px-4': display.xs }]"
            >
            </v-btn-icon>
          </div>
        </template>
        <span>Settings</span>
      </v-tooltip>
    </template>
    <v-list density="compact" variant="flat" class="py-0">
      <v-list-item
        v-if="billingStore.billingExists"
        prepend-icon="mdi-credit-card-outline"
        title="Billing"
        data-testid="settingsMenu.billing"
        @click="openBillingPortal"
      />
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { useDisplay } from "vuetify";
import { useBillingStore } from "../../../stores/billingStore";
import { SubscriptionService } from "../../Subscription/services/subscription-service";

const display = useDisplay();
const billingStore = useBillingStore();

async function openBillingPortal(): Promise<void> {
  const { url } = await SubscriptionService.createBillingSession();
  window.open(url, '_blank');
}
</script>
